<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>名下会员</h1>
        <p>优先运营权：可查看、下载这些会员的全部作品，并可划拨积分。不能修改或删除作品。积分池剩余 {{ pool }}，划拨后会员即可用于创作。</p>
      </div>
    </div>
    <div class="ch-panel">
      <div class="ch-filters">
        <label>搜索
          <span class="search-box">
            <input v-model="keyword" placeholder="会员名称 / 手机" @keyup.enter="reload" />
            <button v-if="keyword" class="clear" type="button" aria-label="清除" @click="clearKeyword">×</button>
          </span>
        </label>
        <button class="ch-btn" type="button" @click="reload">查询</button>
      </div>
      <table class="ch-table">
        <thead>
          <tr>
            <th>会员</th>
            <th>手机</th>
            <th>当前积分</th>
            <th>绑定时间</th>
            <th>划拨积分</th>
            <th>划拨记录</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in list" :key="row.userId">
            <td>{{ row.nickname || ('会员' + row.userId) }}</td>
            <td>{{ row.phone || '—' }}</td>
            <td>{{ row.points || 0 }}</td>
            <td>{{ timeText(row.boundAt) }}</td>
            <td v-if="Number(row.shareConsent) === 1">
              <input v-model="alloc[row.userId]" placeholder="积分" />
              <button class="ch-link" type="button" @click="give(row)">划拨</button>
            </td>
            <td v-else>未同意，不能划拨</td>
            <td>
              <span v-if="Number(row.transferTimes)">{{ row.transferTimes }} 次 · {{ row.transferPoints }} 分</span>
              <span v-else>—</span>
              <button class="ch-link" type="button" @click="showRecords(row)">查看</button>
            </td>
          </tr>
          <tr v-if="!list.length"><td colspan="6" class="ch-empty">{{ keyword.trim() ? '没有匹配的会员' : '还没有通过推广码绑定的会员' }}</td></tr>
        </tbody>
      </table>
      <div class="pager" v-if="total">
        <button class="ch-btn" type="button" :disabled="page <= 1" @click="go(page - 1)">上一页</button>
        <span>第 {{ page }} / {{ pages }} 页，共 {{ total }} 人</span>
        <button class="ch-btn" type="button" :disabled="page >= pages" @click="go(page + 1)">下一页</button>
      </div>
    </div>
    <div class="ch-panel" style="margin-top:16px">
      <h2>划拨记录 <small v-if="recordScope">· {{ recordScope }}</small></h2>
      <button v-if="recordUser" class="ch-link" type="button" @click="showRecords(null)">{{ keyword.trim() ? '查看搜索结果' : '查看全部' }}</button>
      <table class="ch-table">
        <thead><tr><th>时间</th><th>会员</th><th>手机</th><th>划拨积分</th></tr></thead>
        <tbody>
          <tr v-for="row in records" :key="row.id">
            <td>{{ timeText(row.createdAt) }}</td>
            <td>{{ row.nickname || ('会员' + row.userId) }}</td>
            <td>{{ row.phone || '—' }}</td>
            <td>{{ row.points }} 分</td>
          </tr>
          <tr v-if="!records.length"><td colspan="4" class="ch-empty">{{ recordScope ? '没有对应的划拨记录' : '还没有划拨记录' }}</td></tr>
        </tbody>
      </table>
      <div class="pager" v-if="recordTotal">
        <button class="ch-btn" type="button" :disabled="recordPage <= 1" @click="goRecords(recordPage - 1)">上一页</button>
        <span>第 {{ recordPage }} / {{ recordPages }} 页，共 {{ recordTotal }} 笔</span>
        <button class="ch-btn" type="button" :disabled="recordPage >= recordPages" @click="goRecords(recordPage + 1)">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getEcoDesk, getEcoMembers, allocateEcoPoints, getEcoTransfers } from '@/api/admin'

export default {
  name: 'PartnerMembers',
  data() {
    return {
      pool: 0,
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      keyword: '',
      alloc: {},
      records: [],
      recordTotal: 0,
      recordPage: 1,
      recordUser: null
    }
  },
  computed: {
    pages() {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    recordPages() {
      return Math.max(1, Math.ceil(this.recordTotal / this.pageSize))
    },
    recordScope() {
      if (this.recordUser) return this.recordUser.nickname || ('会员' + this.recordUser.userId)
      const word = this.keyword.trim()
      if (!word) return ''
      if (this.list.length === 1) {
        const row = this.list[0]
        return row.nickname || ('会员' + row.userId)
      }
      return '搜索「' + word + '」'
    }
  },
  created() {
    this.loadPool()
    this.load()
    this.loadRecords()
  },
  methods: {
    async loadPool() {
      const desk = await getEcoDesk()
      this.pool = (desk && desk.points) || 0
    },
    async load() {
      const result = await getEcoMembers({
        page: this.page,
        pageSize: this.pageSize,
        keyword: this.keyword.trim() || undefined
      })
      this.list = (result && result.list) || []
      this.total = Number((result && result.total) || 0)
    },
    reload() {
      this.page = 1
      this.recordPage = 1
      this.recordUser = null
      this.load()
      this.loadRecords()
    },
    clearKeyword() {
      this.keyword = ''
      this.reload()
    },
    go(page) {
      this.page = page
      this.load()
    },
    async give(row) {
      const points = this.alloc[row.userId]
      if (!points) return
      await allocateEcoPoints({ userId: row.userId, points })
      this.$set(this.alloc, row.userId, '')
      this.$message.success('已划拨，会员可直接用于创作')
      this.loadPool()
      this.load()
      this.recordPage = 1
      this.loadRecords()
    },
    showRecords(row) {
      this.recordUser = row
      this.recordPage = 1
      this.loadRecords()
    },
    goRecords(page) {
      this.recordPage = page
      this.loadRecords()
    },
    async loadRecords() {
      const result = await getEcoTransfers({
        page: this.recordPage,
        pageSize: this.pageSize,
        userId: this.recordUser ? this.recordUser.userId : undefined,
        keyword: this.recordUser ? undefined : (this.keyword.trim() || undefined)
      })
      this.records = (result && result.list) || []
      this.recordTotal = Number((result && result.total) || 0)
    },
    timeText(value) {
      if (!value) return '—'
      return String(value).replace('T', ' ').slice(0, 19)
    }
  }
}
</script>

<style scoped>
.pager { display: flex; align-items: center; gap: 12px; margin-top: 14px; color: #5c6780; font-size: 13px; }
input { margin-left: 8px; height: 32px; border: 1px solid #d9dfec; border-radius: 8px; padding: 0 8px; width: 220px; }
td input { width: 90px; margin: 0 8px 0 0; }
h2 { margin: 0 0 12px; font-size: 16px; }
h2 small { font-weight: 500; color: #5c6780; }
.search-box { position: relative; display: inline-block; margin-left: 8px; }
.search-box input { margin-left: 0; width: 220px; padding-right: 28px; }
.clear {
  position: absolute;
  top: 1px;
  right: 1px;
  width: 28px;
  height: 30px;
  border: 0;
  border-radius: 0 8px 8px 0;
  background: transparent;
  color: #98a2b3;
  font-size: 16px;
  line-height: 28px;
  cursor: pointer;
}
.clear:hover { color: #1e2a78; }
</style>
